// Ids: payloads carry Swift `uuidString` (upper-case); server envelopes are lower-case. Never re-case a value that was
// not edited; compare with `sameId` (WEB_PLAN.md §0).

/** A new upper-case UUID, like Swift `UUID().uuidString`. */
export function newId(): string {
  return crypto.randomUUID().toUpperCase();
}

export function sameId(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  return a.toLowerCase() === b.toLowerCase();
}

/** Map key for an id (lower-case). */
export function idKey(id: string): string {
  return id.toLowerCase();
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: unknown): value is string {
  return typeof value === 'string' && UUID_RE.test(value);
}
